import { renderingRule, renderIfTokensMatch, renderWithAttrs } from '../utils/markdown.plugin.utils.js';

const AddOrderedListClass = renderingRule('ordered_list_open', renderIfTokensMatch({
  level: 0
}, renderWithAttrs({
  class: 'top-level'
})));
var StyleLists = [AddOrderedListClass];

export { AddOrderedListClass, StyleLists as default };
